import React from 'react';

export const LogoSvg = ({ size = 32 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 103 103" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M39.4835 21.0336C51.0287 9.41666 69.7473 9.41715 81.2923 21.0343C92.8371 32.6515 92.8371 51.4864 81.2923 63.1035L63.0234 81.4866C51.3069 93.2762 32.45 93.416 20.9048 81.799C9.35959 70.1817 9.498 51.2064 21.2145 39.4167L39.4835 21.0336Z" fill="url(#paint0_linear_898_179)"/>
    <path d="M69.6151 32.9278C79.3253 42.6987 78.9317 58.9364 68.736 69.1958C58.5403 79.4551 42.4034 79.8512 32.6932 70.0803C22.983 60.3095 23.3766 44.0718 33.5723 33.8124C43.768 23.553 59.9049 23.157 69.6151 32.9278Z" fill="white"/>
    <path d="M51.1712 32.0027C52.5403 32.0377 53.6383 33.1709 53.6383 34.5554V68.3778L53.6378 68.3934C53.5115 71.7726 48.6934 71.7105 48.5677 68.3937L48.5671 68.378V34.5554C48.5671 33.1461 49.7059 32.002 51.106 32.002L51.1712 32.0027ZM58.8936 38.3327C60.2938 38.3327 61.4329 39.4772 61.4329 40.8865V62.0876L61.4323 62.1034C61.3077 65.4132 56.4896 65.4891 56.3619 62.1034L56.3613 62.0878V40.8865C56.3613 39.4802 57.494 38.3328 58.8936 38.3327ZM57.6289 63.2454C57.6366 63.2537 57.6447 63.2616 57.6524 63.2697C57.626 63.2419 57.6001 63.2134 57.5754 63.1833L57.6289 63.2454ZM60.5077 62.6539C60.4589 62.7988 60.3946 62.9299 60.3174 63.047C60.3792 62.9533 60.4328 62.8507 60.4767 62.7392C60.4877 62.7113 60.4979 62.6829 60.5077 62.6539ZM43.3118 41.4621C44.7114 41.4621 45.8443 42.6094 45.8443 44.0157V58.9057L45.8437 58.9212C45.7174 62.3007 40.8991 62.2385 40.7733 58.9219L40.7727 58.9061V44.0157C40.7727 42.6063 41.9117 41.4621 43.3118 41.4621ZM66.7532 45.9747C68.1231 46.0096 69.2267 47.1398 69.2269 48.5271V54.4348L69.2264 54.4507C69.102 57.7599 64.2835 57.8375 64.1559 54.4507L64.1553 54.4352V48.5271C64.1554 47.1208 65.2885 45.974 66.6877 45.9739L66.7532 45.9747ZM35.583 47.7939C36.9522 47.829 38.0499 48.9622 38.05 50.3465V52.6156L38.0494 52.6312C37.923 56.0119 33.1051 55.9467 32.9791 52.6318L32.9785 52.6159V50.3465C32.9786 48.9371 34.1177 47.793 35.5177 47.793L35.583 47.7939ZM35.903 54.273C35.898 54.2741 35.893 54.2748 35.8881 54.2758C35.9186 54.2694 35.949 54.2627 35.9791 54.2547L35.903 54.273ZM37.225 50.2579C37.2265 50.2873 37.2272 50.3169 37.2272 50.3466V52.6001L37.2273 50.3465C37.2273 50.287 37.2243 50.2282 37.2185 50.1703L37.225 50.2579ZM37.1502 49.834C37.1752 49.915 37.1946 49.9985 37.2076 50.0841L37.1925 49.9991C37.1811 49.943 37.1669 49.8879 37.1502 49.834ZM35.6922 48.6297C36.2662 48.6887 36.7572 49.0355 37.0207 49.5245C36.8494 49.2067 36.5821 48.9489 36.2583 48.7912C36.2085 48.7669 36.1573 48.745 36.105 48.7256C35.948 48.6674 35.7802 48.632 35.6055 48.623L35.6922 48.6297ZM34.906 48.7343C34.8612 48.7515 34.8171 48.7703 34.7742 48.7912L34.8502 48.7566C34.8686 48.7488 34.8873 48.7415 34.906 48.7343ZM65.5387 47.2504C65.5288 47.2595 65.5194 47.269 65.5097 47.2783C65.5392 47.25 65.5693 47.2223 65.6008 47.1961L65.5387 47.2504ZM58.8057 39.1626C58.7185 39.1671 58.6329 39.1782 58.5495 39.1955C58.4939 39.207 58.4392 39.2214 58.3857 39.2382C58.3322 39.2551 58.2798 39.2745 58.2287 39.2964C58.4076 39.2198 58.602 39.1731 58.8057 39.1626Z" fill="url(#paint1_linear_898_179)"/>
    <defs>
      <linearGradient id="paint0_linear_898_179" x1="20.9044" y1="81.7986" x2="83.5944" y2="23.3502" gradientUnits="userSpaceOnUse">
        <stop stopColor="#4ECDEE"/>
        <stop offset="0.350962" stopColor="#326BCC"/>
        <stop offset="0.658654" stopColor="#886FFD"/>
        <stop offset="1" stopColor="#C7B4F5"/>
      </linearGradient>
      <linearGradient id="paint1_linear_898_179" x1="67.6571" y1="51.4533" x2="34.5484" y2="51.4533" gradientUnits="userSpaceOnUse">
        <stop stopColor="#836FFA"/>
        <stop offset="1" stopColor="#326BCC"/>
      </linearGradient>
    </defs>
  </svg>
);

export const ContactIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

export const UserIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

export const LogoutIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

export const SettingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

export const RoutingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 3 21 3 21 8" />
    <line x1="4" y1="20" x2="21" y2="3" />
    <polyline points="21 16 21 21 16 21" />
    <line x1="15" y1="15" x2="21" y2="21" />
    <line x1="4" y1="4" x2="9" y2="9" />
  </svg>
);

export const PhoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l2.19-2.19a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

export const MobileIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="6" y="2" width="12" height="20" rx="2" />
    <line x1="10" y1="5" x2="14" y2="5" />
    <line x1="11" y1="19" x2="13" y2="19" />
  </svg>
);

export const KakaoBubbleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path fillRule="evenodd" d="M12 18.75c-.591 0-1.1697-.0413-1.7317-.1209-.5626.3965-3.813 2.6797-4.1198 2.7225 0 0-.1258.0489-.2328-.0141s-.0876-.2282-.0876-.2282c.0322-.2198.8426-3.0183.992-3.5333-2.7452-1.36-4.5701-3.7686-4.5701-6.5135C2.25 6.8168 6.6152 3.375 12 3.375s9.75 3.4418 9.75 7.6875c0 4.2457-4.3652 7.6875-9.75 7.6875zM8.0496 9.8672h-.8777v3.3417c0 .2963-.2523.5372-.5625.5372s-.5625-.2409-.5625-.5372V9.8672h-.8777c-.3044 0-.552-.2471-.552-.5508s.2477-.5508.552-.5508h2.8804c.3044 0 .552.2471.552.5508s-.2477.5508-.552.5508zm10.9879 2.9566a.558.558 0 0 1 .108.4167.5588.5588 0 0 1-.2183.371.5572.5572 0 0 1-.3383.1135.558.558 0 0 1-.4493-.2236l-1.3192-1.7479-.1952.1952v1.2273a.5635.5635 0 0 1-.5627.5628.563.563 0 0 1-.5625-.5625V9.3281c0-.3102.2523-.5625.5625-.5625s.5625.2523.5625.5625v1.209l1.5694-1.5694c.0807-.0807.1916-.1252.312-.1252.1404 0 .2814.0606.3871.1661.0985.0984.1573.2251.1654.3566.0082.1327-.036.2542-.1241.3425l-1.2818 1.2817 1.3845 1.8344zm-8.3502-3.5023c-.095-.2699-.3829-.5475-.7503-.5557-.3663.0083-.6542.2858-.749.5551l-1.3455 3.5415c-.1708.5305-.0217.7272.1333.7988a.8568.8568 0 0 0 .3576.0776c.2346 0 .4139-.0952.4678-.2481l.2787-.7297 1.7152.0001.2785.7292c.0541.1532.2335.2484.4681.2484a.8601.8601 0 0 0 .3576-.0775c.1551-.0713.3041-.2681.1329-.7999l-1.3449-3.5398zm-1.3116 2.4433l.5618-1.5961.5618 1.5961H9.3757zm5.9056 1.3836c0 .2843-.2418.5156-.5391.5156h-1.8047c-.2973 0-.5391-.2314-.5391-.5156V9.3281c0-.3102.2576-.5625.5742-.5625s.5742.2523.5742.5625v3.3047h1.1953c.2974 0 .5392.2314.5392.5156z" />
  </svg>
);

export const SmsIcon = () => (
  <svg width="20" height="20" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
    <path d="M348.5-531.5Q360-543 360-560t-11.5-28.5Q337-600 320-600t-28.5 11.5Q280-577 280-560t11.5 28.5Q303-520 320-520t28.5-11.5Zm160 0Q520-543 520-560t-11.5-28.5Q497-600 480-600t-28.5 11.5Q440-577 440-560t11.5 28.5Q463-520 480-520t28.5-11.5Zm160 0Q680-543 680-560t-11.5-28.5Q657-600 640-600t-28.5 11.5Q600-577 600-560t11.5 28.5Q623-520 640-520t28.5-11.5ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
  </svg>
);

export const SendIcon = () => (
  <svg width="20" height="20" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
    <path d="M120-160v-640l760 320-760 320Zm80-120 474-200-474-200v140l240 60-240 60v140Zm0 0v-400 400Z" />
  </svg>
);

export const ScheduleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </svg>
);

export const IvrIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 7 12 15 8 11 4 15" />
    <path d="M21 3h-6v6" />
    <path d="M21 3l-9 9" />
  </svg>
);

export const MusicIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 18V5l12-2v13" />
    <circle cx="6" cy="18" r="3" />
    <circle cx="18" cy="16" r="3" />
  </svg>
);

export const SearchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <line x1="9" y1="3" x2="9" y2="21" />
    <line x1="15" y1="3" x2="15" y2="21" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="3" y1="15" x2="21" y2="15" />
  </svg>
);

export const EtcIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
    <line x1="7" y1="7" x2="7.01" y2="7" />
    <circle cx="11" cy="11" r="0.5" fill="currentColor" />
    <circle cx="13" cy="11" r="0.5" fill="currentColor" />
    <circle cx="15" cy="11" r="0.5" fill="currentColor" />
  </svg>
);

export const MenuFoldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 17l-5-5 5-5" />
    <path d="M18 17l-5-5 5-5" />
  </svg>
);

export const MenuUnfoldIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M13 17l5-5-5-5" />
    <path d="M6 17l5-5-5-5" />
  </svg>
);

export const PlayIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);

export const FlagIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
    <line x1="4" y1="22" x2="4" y2="15" />
  </svg>
);

export const StopIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
  </svg>
);

export const LoadingIcon = ({ size = 20, color = "currentColor" }: { size?: number; color?: string }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    style={{ animation: 'spin 1s linear infinite' }}
  >
    <style>
      {`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}
    </style>
    <circle 
      cx="12" 
      cy="12" 
      r="10" 
      stroke={color} 
      strokeWidth="4" 
      strokeOpacity="0.2" 
    />
    <path 
      d="M12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.0434 16.4527" 
      stroke={color} 
      strokeWidth="4" 
      strokeLinecap="round" 
    />
  </svg>
);

export const RepeatIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m17 2 4 4-4 4" />
    <path d="M3 11v-1a4 4 0 0 1 4-4h14" />
    <path d="m7 22-4-4 4-4" />
    <path d="M21 13v1a4 4 0 0 1-4 4H3" />
  </svg>
);

export const XIcon = ({ size = 16 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const StatsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
  </svg>
);

export const CallHistoryIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4.5 6.5a2 2 0 0 1 2-2h1.2l1.7 4.1-1.8 1.5a11.7 11.7 0 0 0 6.3 6.3l1.5-1.8 4.1 1.7v1.2a2 2 0 0 1-2 2h-.7A12.3 12.3 0 0 1 4.5 7.2z" />
    <circle cx="17" cy="7" r="3.5" />
    <path d="M17 5.5V7h1.2" />
  </svg>
);

export const BroomIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 240 240" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="빗자루 아이콘">
    <defs>
      <linearGradient id="broom-handle" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#c58a3a"/>
        <stop offset="100%" stopColor="#8b5a2b"/>
      </linearGradient>
      <linearGradient id="broom-bristle" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#f2d27a"/>
        <stop offset="100%" stopColor="#c79a3b"/>
      </linearGradient>
    </defs>

    {/* 손잡이 */}
    <g transform="rotate(-35 120 120)">
      <rect x="112" y="20" width="16" height="130" rx="8" fill="url(#broom-handle)"/>
      <circle cx="120" cy="30" r="4" fill="#6e451f"/>

      {/* 묶는 부분 */}
      <rect x="98" y="145" width="44" height="14" rx="4" fill="#9a6a2f"/>
      <rect x="101" y="148" width="38" height="4" rx="2" fill="#d8b06a"/>

      {/* 빗자루 솔 */}
      <path d="M88 158
               L152 158
               L165 210
               Q120 224 75 210
               Z"
            fill="url(#broom-bristle)"/>

      {/* 솔 디테일 */}
      <path d="M95 162 L88 208" stroke="#a97b2d" strokeWidth="2" strokeLinecap="round"/>
      <path d="M105 162 L100 212" stroke="#a97b2d" strokeWidth="2" strokeLinecap="round"/>
      <path d="M115 162 L113 214" stroke="#a97b2d" strokeWidth="2" strokeLinecap="round"/>
      <path d="M125 162 L127 214" stroke="#a97b2d" strokeWidth="2" strokeLinecap="round"/>
      <path d="M135 162 L140 212" stroke="#a97b2d" strokeWidth="2" strokeLinecap="round"/>
      <path d="M145 162 L152 208" stroke="#a97b2d" strokeWidth="2" strokeLinecap="round"/>
    </g>
  </svg>
);
